import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../actions/index.types';
import * as visitReq from '../../../../axios/request/SocietyPortal/VmsReqs/VisitReqs';
import * as preApprovalReq from '../../../../axios/request/SocietyPortal/VmsReqs/PreApprovalReqs';
import * as gatePassReq from '../../../../axios/request/SocietyPortal/VmsReqs/GatePassReqs';
import * as deliveryReq from '../../../../axios/request/SocietyPortal/VmsReqs/DeliveryReqs';
import * as cabReq from '../../../../axios/request/SocietyPortal/VmsReqs/CabReqs';
import * as miscReq from '../../../../axios/request/SocietyPortal/VmsReqs/VmsMiscReqs';

// The VMS endpoints all answer with the same envelope, so one worker shape
// covers every one of them. `shape` decides what lands in the reducer:
//   'list'   → { rows, pagination } read off data + meta.pagination
//   'single' → data as-is
const worker = (baseType, request, shape = 'single') => function* run(action) {
    try {
        const result = yield call(request, action);
        if (result?.success === true) {
            const payload = shape === 'list'
                ? { rows: result.data, pagination: result.meta?.pagination }
                : result.data;
            yield put({ type: `${baseType}_SUCCESS`, payload });
            // Screens drive their own refetch and navigation from here, which is
            // why the result is handed back whole — a created visit's `status`
            // decides which screen comes next.
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: `${baseType}_FAILURE`, message: result?.response?.data?.message });
            action.data?.onError?.(result);
        }
    } catch (e) {
        yield put({ type: `${baseType}_FAILURE`, message: e?.message });
        action.data?.onError?.(e);
    }
};

const WATCHERS = [
    // visits
    [types.SOCIETY_GET_VISITS_LIST, visitReq.getVisitsListReq, 'list'],
    [types.SOCIETY_GET_VISIT_DETAILS, visitReq.getVisitDetailsReq],
    [types.SOCIETY_CREATE_VISIT, visitReq.createVisitReq],
    [types.SOCIETY_UPDATE_VISIT, visitReq.updateVisitReq],
    [types.SOCIETY_DELETE_VISIT, visitReq.deleteVisitReq],
    [types.SOCIETY_APPROVE_VISIT, visitReq.approveVisitReq],
    [types.SOCIETY_REJECT_VISIT, visitReq.rejectVisitReq],
    [types.SOCIETY_VERIFY_VISIT_OTP, visitReq.verifyVisitOtpReq],
    [types.SOCIETY_CHECK_IN_VISIT, visitReq.checkInVisitReq],
    [types.SOCIETY_CHECK_OUT_VISIT, visitReq.checkOutVisitReq],

    // pre-approvals
    [types.SOCIETY_GET_PRE_APPROVALS_LIST, preApprovalReq.getPreApprovalsListReq, 'list'],
    [types.SOCIETY_GET_PRE_APPROVAL_DETAILS, preApprovalReq.getPreApprovalDetailsReq],
    [types.SOCIETY_CREATE_PRE_APPROVAL, preApprovalReq.createPreApprovalReq],
    [types.SOCIETY_UPDATE_PRE_APPROVAL, preApprovalReq.updatePreApprovalReq],
    [types.SOCIETY_DELETE_PRE_APPROVAL, preApprovalReq.deletePreApprovalReq],

    // gate passes
    [types.SOCIETY_GET_GATE_PASSES_LIST, gatePassReq.getGatePassesListReq, 'list'],
    [types.SOCIETY_GET_GATE_PASS_DETAILS, gatePassReq.getGatePassDetailsReq],
    [types.SOCIETY_CREATE_GATE_PASS, gatePassReq.createGatePassReq],
    [types.SOCIETY_UPDATE_GATE_PASS, gatePassReq.updateGatePassReq],
    [types.SOCIETY_DELETE_GATE_PASS, gatePassReq.deleteGatePassReq],
    [types.SOCIETY_REVOKE_GATE_PASS, gatePassReq.revokeGatePassReq],

    // deliveries
    [types.SOCIETY_GET_DELIVERIES_LIST, deliveryReq.getDeliveriesListReq, 'list'],
    [types.SOCIETY_GET_DELIVERY_DETAILS, deliveryReq.getDeliveryDetailsReq],
    [types.SOCIETY_CREATE_DELIVERY, deliveryReq.createDeliveryReq],
    [types.SOCIETY_UPDATE_DELIVERY, deliveryReq.updateDeliveryReq],
    [types.SOCIETY_DELETE_DELIVERY, deliveryReq.deleteDeliveryReq],
    [types.SOCIETY_COMPLETE_DELIVERY, deliveryReq.completeDeliveryReq],

    // cabs
    [types.SOCIETY_GET_CABS_LIST, cabReq.getCabsListReq, 'list'],
    [types.SOCIETY_GET_CAB_DETAILS, cabReq.getCabDetailsReq],
    [types.SOCIETY_CREATE_CAB, cabReq.createCabReq],
    [types.SOCIETY_UPDATE_CAB, cabReq.updateCabReq],
    [types.SOCIETY_DELETE_CAB, cabReq.deleteCabReq],
    [types.SOCIETY_COMPLETE_CAB, cabReq.completeCabReq],

    // activity logs — the export answers with a flat array, not a page
    [types.SOCIETY_GET_VMS_ACTIVITY_LOGS, miscReq.getActivityLogsListReq, 'list'],
    [types.SOCIETY_EXPORT_VMS_ACTIVITY_LOGS, miscReq.exportActivityLogsReq],

    // settings
    [types.SOCIETY_GET_VMS_SETTINGS, miscReq.getVmsSettingsReq],
    [types.SOCIETY_UPDATE_VMS_SETTINGS, miscReq.updateVmsSettingsReq],
];

export default function* VmsSaga() {
    for (const [actionType, request, shape] of WATCHERS) {
        yield takeLatest(actionType, worker(actionType, request, shape));
    }
}
